export default "__VITE_ASSET__DY2hykrW__"